import * as React from "react";
import * as moment from 'moment';
import {Modal} from "antd";
import locales from "../locales";
import ItemDeleteForm from "./ItemDeleteForm";

interface Props {
  onCancel: () => void;
  onSubmit: (deleteDate: moment.Moment) => void;
}

class ItemDeleteModal extends React.Component<Props, {}> {

  public render(): React.ReactNode {
    const {onSubmit, onCancel} = this.props;
    return (
      <Modal
        title={locales.item_delete_confirm}
        visible={true}
        footer={null}
        onCancel={onCancel}
        destroyOnClose={true}
      >
        <ItemDeleteForm
          onFormCancel={onCancel}
          onFormSubmit={onSubmit}
        />
      </Modal>
    );
  }
}

export default ItemDeleteModal;


// WEBPACK FOOTER //
// ./src/item-details/ItemDeleteModal.tsx